import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "./../../Components/Table";
import Api from "../../Hooks/Api";

import swal from "sweetalert";
const VetingSession = () => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setView] = useState(false);

  const [update, setUpdate] = useState(false);
  const [activeTab, setActiveTab] = useState("session");
  const [PageRole] = useState("Applications");
  const [RowData, setRowData] = useState([]);
  const [sessionsApplications, setSessionsApplications] = useState([]);
  const [allApplications, setAllApplications] = useState([]);
  const [vettingMembers, setVettingMembers] = useState([]);

  const [inputsDocuments, setInputsDocuments] = useState({});
  const [staffOptions, setStaffOptions] = useState([]);
  const url = "api/applicants";

  const FetchAllApplication = async () => {
    setRowData([]);
    try {
      Api.get("api/applications/getAll?page=0&size=10")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setAllApplications(data?.applications);
            const totalPages = data.totalPages;
            for (let i = 0; i < totalPages; i++) {
              let nextPage = parseFloat(i) + parseFloat(1);
              Api.get("api/applications/getAll?page=" + nextPage + "&size=10")
                .then(function (response) {
                  if (response.status === 200) {
                    const data = response.data;
                    setAllApplications((prev) => [
                      ...prev,
                      ...data?.applications,
                    ]);
                  }
                })
                .catch(function (error) {})
                .then(function () {
                  // always executed
                });
            }
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchStaff = async () => {
    try {
      Api.get("/api/staff")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setStaffOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };

  const MoreActions = (props) => {
    return (
      <span>
        <a
          class="btn btn-secondary btn-sm dropdown-toggle"
          href="#"
          role="button"
          id="dropdownMenuLink"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          More Actions&nbsp;&nbsp;
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleView(props.selecteditem, e)}
          >
            Manage session
          </a>
        </div>
      </span>
    );
  };
  const setApplicationsdata = async (data) => {
    const rows = data;

    rows.forEach((k) => {
      const Rowdata = {
        id: k.id,
        venue: k.venue,
        sessionDate: new Date(k.sessionDate).toLocaleDateString("en-GB"),
        Actions: <MoreActions selecteditem={k} />,
      };
      setRowData((inputs) => [...inputs, Rowdata]);
    });
  };
  const fetchSessionsApplications = async (sessionId) => {
    try {
      Api.get("api/sessionsApplication/getBySessionId?sessionId=" + sessionId)
        .then(function (response) {
          if (response.status === 200) {
            setSessionsApplications(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };

  const fetchVettingMembers = async (sessionId) => {
    try {
      Api.get("api/vettingMembers/getBySessionId?sessionId=" + sessionId)
        .then(function (response) {
          if (response.status === 200) {
            setVettingMembers(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };

  const FetchAll = async () => {
    setRowData([]);
    try {
      Api.get("api/vettingSessions")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setApplicationsdata(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    FetchAll();
    fetchStaff();
    FetchAllApplication();
  }, []);

  const handleView = (k) => {
    setInputs(k);

    setInputsDocuments((inputsDocuments) => ({
      ...inputsDocuments,
      ["sessionId"]: k.id,
    }));

    if (k.id) {
      fetchSessionsApplications(k.id);
      fetchVettingMembers(k.id);
      setView(true);
      setOpen(true);
    } else {
      alert("Select a record to view");
    }
  };
  const handleCloseModal = () => {
    setInputs({});
    setOpen(false);
    setView(false);
    setUpdate(false);
  };

  const HandleUpdate = (inputs, url) => {
    useUpdate(url, inputs);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };

  const handleSubmitvettingSessions = (event) => {
    event.preventDefault();

    HandleSave(inputs, "api/vettingSessions", "approval");
    setActiveTab("members");
  };

  const handleSubmitApplications = (event) => {
    event.preventDefault();
    if (
      !inputsDocuments.sessionId ||
      inputsDocuments.sessionId == "undefined"
    ) {
      alert("Add or select Session first");
      return;
    }
    let body = {
      sessionId: inputsDocuments.sessionId,
      applicationId: inputsDocuments.applicationId,
    };
    HandleSave(body, "api/sessionsApplication", "seassionApplication");
  };
  const handleSubmitMembers = (event) => {
    event.preventDefault();
    if (
      !inputsDocuments.sessionId ||
      inputsDocuments.sessionId == "undefined"
    ) {
      alert("Add or select Session first");
      return;
    }
    let body = {
      sessionId: inputsDocuments.sessionId,
      staffId: inputsDocuments.staffId,
    };
    HandleSave(body, "api/vettingMembers", "approval");
  };
  const handleInoutChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };
  const handleDocumentsInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputsDocuments((documents) => ({ ...documents, [name]: value }));
  };
  const handleOpenModal = () => {
    const currentUserName = window.sessionStorage.getItem("UserName");
    setInputs({ createdBy: currentUserName });
    setOpen(true);
  };
  const useSave = (url = ``, inputs = {}, menu = ``, config = {}) => {
    let data;
    let headers;
    if (inputs instanceof FormData) {
      data = inputs;
      headers = { ...config.headers }; // Don't set Content-Type header, let the browser set it
    } else {
      data = JSON.stringify(inputs);
      headers = { "Content-Type": "application/json", ...config.headers };
    }
    Api.post(url, data, { headers })
      .then((response) => {
        if (response.data.resultCode === "00") {
          if (menu === "approval") {
            var result = JSON.parse(response.data.data);

            setInputsDocuments((inputsDocuments) => ({
              ...inputsDocuments,
              ["sessionId"]: result.id,
            }));
          }

          swal("", "saved", "success");
        } else {
          swal("", response.data.description, "error");
        }
      })
      .catch((error) => {
        swal("", "Failed", "error");
      });
  };
  const HandleSave = (inputs, url, menu) => {
    useSave(url, inputs, menu);
    setTimeout(function () {
      FetchAll();
      fetchSessionsApplications(inputsDocuments.sessionId);
      fetchVettingMembers(inputsDocuments.sessionId);
    }, 4000);
  };

  const CallDeleteHook = (id) => {
    useDelete(url + "/delete?id=" + id);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };
  const HandleDelete = (k) => {
    if (k.id) {
      CallDeleteHook(k.id);
    } else {
      alert("Select a record to delete");
    }
  };

  const columns = [
    { label: "Venue", field: "venue", sort: "asc" },
    { label: "SessionDate", field: "sessionDate", sort: "asc" },
    { label: "Actions", field: "Actions", sort: "asc" },
  ];

  const ActionsBtn = () => (
    <div>
      {useValidateRole(PageRole, "Edit") && (
        <button
          className="btn btn-primary p-2"
          type="button"
          onClick={handleView}
        >
          Veting Session
        </button>
      )}
      &nbsp; &nbsp;
      {useValidateRole(PageRole, "Remove") && (
        <button onClick={HandleDelete} className="btn btn-danger p-2">
          Delete
        </button>
      )}
      &nbsp;
      <button
        className="btn btn-warning p-2"
        type="button"
        onClick={handleCloseModal}
      >
        Close
      </button>
    </div>
  );

  return (
    <div id="content" className="content">
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>
        <li className="breadcrumb-item active">Sessions Management</li>
      </ol>
      <h1 className="page-header mb-3">Sessions Management</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div className="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            {useValidateRole(PageRole, "AddNew") && (
              <button
                onClick={handleOpenModal}
                className="btn btn-primary p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; New Session&nbsp;
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={RowData} columns={columns} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="80%" height="80%" effect="fadeInUp">
        <div style={{ overflowY: "auto", height: "100%" }}>
          <a className="close" onClick={handleCloseModal}>
            &times;
          </a>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                <div>
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${activeTab === "session" ? "active" : ""}`}
                        id="session-tab"
                        onClick={() => setActiveTab("session")}
                        role="tab"
                        aria-selected={activeTab === "session"}
                      >
                        Sessions Management
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${activeTab === "members" ? "active" : ""}`}
                        id="members-tab"
                        onClick={() => setActiveTab("members")}
                        role="tab"
                        aria-selected={activeTab === "members"}
                      >
                        Vetting Members
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${activeTab === "Applications" ? "active" : ""}`}
                        id="Applications-tab"
                        onClick={() => setActiveTab("Applications")}
                        role="tab"
                        aria-selected={activeTab === "Applications"}
                      >
                        Applications
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className={`tab-pane fade ${activeTab === "session" ? "show active" : ""}`}
                      id="areas-tab-pane"
                      role="tabpanel"
                      aria-labelledby="session-tab"
                    >
                      <form
                        className="form-horizontal"
                        onSubmit={handleSubmitvettingSessions}
                      >
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="Datereceived"
                                className="fontWeight-bold"
                              >
                                Date
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                name="sessionDate"
                                required
                                value={inputs.sessionDate}
                                onChange={handleInoutChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="Datereceived"
                                className="fontWeight-bold"
                              >
                                Venue
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="venue"
                                required
                                value={inputs.venue}
                                onChange={handleInoutChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div className="d-flex flex-row">
                            <button
                              className="btn btn-primary p-2"
                              type="submit"
                            >
                              Save session
                            </button>
                            &nbsp;
                            <button
                              className="btn btn-warning p-2"
                              type="button"
                              onClick={handleCloseModal}
                            >
                              Close
                            </button>
                          </div>
                          <br />
                        </div>
                      </form>
                    </div>
                    <div
                      className={`tab-pane fade ${activeTab === "members" ? "show active" : ""}`}
                      id="areas-tab-pane"
                      role="tabpanel"
                      aria-labelledby="members-tab"
                    >
                      <form
                        className="form-horizontal"
                        onSubmit={handleSubmitMembers}
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label
                                htmlFor="applicationType"
                                className="font-weight-bold"
                              >
                                Select Staff
                              </label>
                              <select
                                className="form-control"
                                name="staffId"
                                required
                                value={inputsDocuments.staffId || ""}
                                onChange={(e) => handleDocumentsInputChange(e)}
                              >
                                <option value="">Select Staff</option>
                                {staffOptions &&
                                  staffOptions.map((types) => (
                                    <option
                                      key={types.staffId}
                                      value={types.staffId}
                                    >
                                      {types.fullName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div className="d-flex flex-row">
                            <button
                              className="btn btn-primary p-2"
                              type="submit"
                            >
                              Submit
                            </button>
                            &nbsp;
                            <button
                              className="btn btn-warning p-2"
                              type="button"
                              onClick={handleCloseModal}
                            >
                              Close
                            </button>
                          </div>
                          <br />
                        </div>
                        <table className="table table-bordered table-striped table-hover">
                          <thead className="table-dark">
                            <tr>
                              <th>#</th>
                              <th>Staff ID</th>
                              <th>PF Number</th>
                              <th>Full Name</th>
                              <th>Venue</th>
                              <th>Session Date</th>
                            </tr>
                          </thead>

                          <tbody>
                            {vettingMembers && vettingMembers.length > 0 ? (
                              vettingMembers.map((member, index) => (
                                <tr key={member.id || index}>
                                  <td>{index + 1}</td>
                                  <td>{member.staffId}</td>
                                  <td>{member.staff?.pfNumber}</td>
                                  <td>{member.staff?.fullName}</td>
                                  <td>{member.sessions?.venue}</td>
                                  <td>
                                    {new Date(
                                      member.sessions?.sessionDate,
                                    ).toLocaleDateString("en-GB")}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="4"
                                  className="text-center text-muted"
                                >
                                  No vetting members found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </form>
                    </div>
                    <div
                      className={`tab-pane fade ${activeTab === "Applications" ? "show active" : ""}`}
                      id="Applications-tab-pane"
                      role="tabpanel"
                      aria-labelledby="Applications-tab"
                    >
                      <div>
                        <form
                          className="form-horizontal"
                          onSubmit={handleSubmitApplications}
                        >
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label
                                  htmlFor="applicationType"
                                  className="font-weight-bold"
                                >
                                  Select Application
                                </label>
                                <select
                                  className="form-control"
                                  name="applicationId"
                                  required
                                  value={inputsDocuments.applicationId || ""}
                                  onChange={(e) =>
                                    handleDocumentsInputChange(e)
                                  }
                                >
                                  <option value="">Select Application</option>
                                  {allApplications &&
                                    allApplications.map((types) => (
                                      <option key={types.id} value={types.id}>
                                        {types.applicant?.fullName +
                                          "-" +
                                          types.applicant?.passportNumber}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <br></br>
                          <table className="table table-bordered table-striped table-hover">
                            <thead className="table-dark">
                              <tr>
                                <th>#</th>
                                <th>Permit Type</th>
                                <th>Application Type</th>
                                <th>Applicant Name</th>
                                <th>Passport Number</th>
                                <th>Submitted Date</th>
                              </tr>
                            </thead>

                            <tbody>
                              {sessionsApplications &&
                              sessionsApplications.length > 0 ? (
                                sessionsApplications.map((member, index) => (
                                  <tr key={member.id || index}>
                                    <td>{index + 1}</td>
                                    <td>{member.permitType}</td>
                                    <td>{member.applicationType}</td>
                                    <td>
                                      {member.applications.applicant.fullName}
                                    </td>
                                    <td>
                                      {
                                        member.applications.applicant
                                          .passportNumber
                                      }
                                    </td>
                                    <td>
                                      {new Date(
                                        member.createdAt,
                                      ).toLocaleDateString("en-GB")}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="4"
                                    className="text-center text-muted"
                                  >
                                    No vetting members found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className="d-flex flex-row">
                              <button
                                className="btn btn-primary p-2"
                                type="submit"
                              >
                                Add aplication
                              </button>
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default VetingSession;
